import * as Html from "../util/Html.ts";
import * as hb from "../handlebars_family.js";
export {init}
Html.registerWidget('widget/extra-image-opener',{init:init})

function init(me){
  var parent  = me.parent();
  me.prevAll(".fw-image-extra").hide();
  me.text(hb.i18n('actions.showAllPictures',parent.find('img')));
  me.on('click',function(){
    var opened = me.data('fw-opened');
    if(opened){
      me.data('fw-opened',false);
      me.prevAll('.fw-image-extra').fadeOut(function(){
        me.prevAll('.fw-image-first').get(0).scrollIntoView();
        me.text(hb.i18n('actions.showAllPictures',parent.find('img')));
      });
     }else{
       me.prevAll('.fw-image-extra').find('img').each(function(idx,node){
         node = $(node);
         if(!node.attr('src')){
           node.attr('src',node.attr('data-src'));
         }
       });
       me.prevAll('.fw-image-extra').fadeIn(function(){
        me.text(hb.i18n('actions.hideAllPictures',parent.find('img')));
      });
      me.data('fw-opened',true);
    }
  });
}